import { render, staticRenderFns } from "./requestNumberAndTypeReports.vue?vue&type=template&id=61ea20f5&scoped=true"
import script from "./requestNumberAndTypeReports.vue?vue&type=script&lang=js"
export * from "./requestNumberAndTypeReports.vue?vue&type=script&lang=js"
import style0 from "./requestNumberAndTypeReports.vue?vue&type=style&index=0&id=61ea20f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ea20f5",
  null
  
)

export default component.exports